import React from 'react'

import './VctFooter.css'

type props = {
  contactEmail: string
  contactPhone?: string
  contactPhoneInternational?: string
}

function VctFooter({ contactEmail, contactPhone, contactPhoneInternational }: props) {

  return (
    <React.Fragment>
      <div className={'vctFooterContainer'}>
        <div className={'vctFooter'}>
          <b>
            For more information contact <a href={'mailto: ' + contactEmail}>{contactEmail}</a>
            {contactPhone && contactPhoneInternational && <> or phone: <a
                href={'tel:' + contactPhoneInternational}>{contactPhone}</a></>}
          </b>
        </div>
      </div>
      <div className={'osmCreditContainer'}>
        <div className={'osmCredit'}>
          <b>© <a href="http://www.openstreetmap.org/copyright" target="_blank"
                  rel="noopener noreferrer">OpenStreetMap</a> contributors</b>
        </div>
      </div>
    </React.Fragment>
  )
}

export default VctFooter
